
/**
 * arg
 * el: element
 *
 * top 当前元素距离顶部的距离
 * window.innerHeight 浏览器窗口的视口的高度
 *
 * return diff
 * diff > 0 说明 el 在 视口上面或者视口中
 * diff < 0 说明 el 在 视口下面
 */

export default (el: HTMLElement): number => {
  const { top } = el.getBoundingClientRect();
  // console.log(top, window.innerHeight, window.innerHeight - top)
  return window.innerHeight - top;
};
